import { DevEnvironment, Environment } from 'src/environments/environment.utils';

export function checkDevEnvironment(environment: Environment): environment is DevEnvironment {
  return !environment.production;
}
